module.exports = __webpack_public_path__ + "img/title.4143ec08.png";